import React, { useState } from 'react';
import { CalculatorIcon, TrendingUpIcon } from 'lucide-react';
export function IncomeCalculator() {
  const [productValue, setProductValue] = useState<number>(19990);
  const [dailySales, setDailySales] = useState<number>(10);
  const dailyIncome = productValue * dailySales;
  const monthlyIncome = dailyIncome * 30;
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <section className="bg-gray-50 py-16 md:py-24 px-4 border-y border-gray-200" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <div className="text-center mb-10" data-id="element-164">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-700 px-6 py-2 rounded-full font-bold text-sm mb-6 gap-2" data-id="element-165">
            <CalculatorIcon className="w-5 h-5" data-id="element-166" />
            SIMULADOR DE INGRESOS
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 leading-tight" data-id="element-167">
            Proyectá tus resultados
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-medium" data-id="element-168">
            Simulá lo que podés ganar por día vendiendo con tu propia tienda un
            producto que te enseñamos a crear de 0 con IA.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-green-500" data-id="element-169">
          <div className="grid md:grid-cols-2" data-id="element-170">
            {/* Inputs Section */}
            <div className="p-8 md:p-10 bg-white" data-id="element-171">
              <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-172">
                Tus números
              </h3>

              <div className="space-y-8" data-id="element-173">
                <div data-id="element-174">
                  <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-175">
                    Valor de tu producto (ARS)
                  </label>
                  <div className="relative" data-id="element-176">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-bold" data-id="element-177">
                      $
                    </span>
                    <input type="number" value={productValue} onChange={e => setProductValue(Number(e.target.value))} className="w-full pl-8 pr-4 py-4 bg-gray-50 border-2 border-gray-200 rounded-xl text-xl font-bold text-gray-900 focus:border-green-500 focus:ring-0 transition-colors" data-id="element-178" />
                  </div>
                </div>

                <div data-id="element-179">
                  <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-180">
                    Ventas estimadas por día
                  </label>
                  <div className="flex items-center gap-4" data-id="element-181">
                    <input type="range" min="1" max="100" value={dailySales} onChange={e => setDailySales(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-green-600" data-id="element-182" />
                    <div className="bg-gray-50 border-2 border-gray-200 rounded-xl px-4 py-3 min-w-[80px] text-center" data-id="element-183">
                      <span className="text-xl font-bold text-gray-900" data-id="element-184">
                        {dailySales}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Results Section */}
            <div className="p-8 md:p-10 bg-gradient-to-br from-gray-900 to-gray-800 text-white flex flex-col justify-center" data-id="element-185">
              <h3 className="text-xl font-bold text-gray-300 mb-8 flex items-center gap-2" data-id="element-186">
                <TrendingUpIcon className="w-6 h-6 text-green-400" data-id="element-187" />
                Tu potencial de ingresos
              </h3>

              <div className="space-y-8" data-id="element-188">
                <div data-id="element-189">
                  <p className="text-gray-400 font-medium mb-1" data-id="element-190">
                    Ingresos Diarios
                  </p>
                  <p className="text-4xl font-black text-white" data-id="element-191">
                    {formatCurrency(dailyIncome)}
                  </p>
                </div>

                <div className="pt-8 border-t border-gray-700" data-id="element-192">
                  <p className="text-green-400 font-bold mb-1 uppercase tracking-wider text-sm" data-id="element-193">
                    Ingresos Mensuales Estimados
                  </p>
                  <p className="text-5xl md:text-6xl font-black text-green-400" data-id="element-194">
                    {formatCurrency(monthlyIncome)}
                  </p>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-8" data-id="element-195">
                * Estos números son una simulación basada en tus ingresos. Los
                resultados reales dependen de tu ejecución y constancia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}